export default __webpack_public_path__ + "dadf06d61c8a4bfea73563584060584b.svg";